import { Network } from '@metrika/api';
import { DelayedRender } from '@metrika/ui-kit';
import { SkeletonText } from '@metrika/ui-kit/carbon';
import React, { useMemo } from 'react';
import { matchPath, useLocation, useParams } from 'react-router-dom';
import { useDashboards } from '../../../charting/hooks';
import { CarbonNavSubLink } from './components';

export const MenuDashboards_: React.FC<{
   onToggle: () => void;
   workspaceId: string;
   menuId?: string;
   pathPrefix?: string;
}> = ({ onToggle, workspaceId, menuId, pathPrefix }) => {
   const { pathname } = useLocation();
   const { network } = useParams<{ network?: Network }>();

   const currentNet = network || 'mainnet';
   const currentNetPath = network ? `/${network}` : '';

   const { data: dashboards, loading: dashLoading } = useDashboards();

   const items = useMemo(
      () =>
         !dashLoading && dashboards
            ? dashboards
                 .filter(
                    (d) =>
                       d.protocol === workspaceId &&
                       ((window.Array.isArray(d.network) && d.network.indexOf(currentNet) >= 0) ||
                          currentNet === d.network) &&
                       !d.hidden &&
                       ((!menuId && !d.sideMenuId) || d.sideMenuId === menuId),
                 )
                 .sort((a, b) =>
                    a.sideMenuLabel === 'Digital Assets'
                       ? (a.menuLabel || a.name).localeCompare(b.menuLabel || b.name)
                       : typeof b.sideOrder === 'number' && typeof a.sideOrder === 'number'
                         ? a.sideOrder - b.sideOrder
                         : 0,
                 )
            : [],
      [dashLoading, dashboards, workspaceId, menuId, currentNet],
   );

   return (
      <>
         {dashLoading && (
            <DelayedRender>
               <SkeletonText />
               <SkeletonText />
            </DelayedRender>
         )}
         {items.map((dash) => (
            <CarbonNavSubLink
               style={{ paddingLeft: 32 }}
               key={dash.dashModelId}
               to={
                  (pathPrefix || '') +
                  (dash.sideLink ||
                     dash.path?.replace('/' + dash.protocol, '/' + dash.protocol + currentNetPath) ||
                     '/' + dash.protocol + currentNetPath + '/dashboard/' + dash.dashModelId)
               }
               isActive={
                  !!matchPath(
                     pathname,
                     (pathPrefix || '') +
                        (dash.path?.replace('/' + dash.protocol, '/' + dash.protocol + currentNetPath) ||
                           '/' + dash.protocol + currentNetPath + '/dashboard/' + dash.dashModelId),
                  )
               }
               title={dash.menuLabel || dash.name}
               onClick={onToggle}
            />
         ))}
      </>
   );
};

export const MenuDashboards = React.memo(MenuDashboards_);
